import classNames from 'classnames';
import React from 'react';

import CrossIcon from '../../icons/CrossIcon';
import styles from './styles.module.scss';

const CrossBtn = ({ onClick, nativeClassName }) => {
    return (
        <button onClick={onClick} className={classNames(styles.cross, !!nativeClassName && nativeClassName)}>
            <CrossIcon />
        </button>
    );
};

export default CrossBtn;
